import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'

export default {
	name: 'shipment-summary',
	components: {
		BasicSelect,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			palletId:'',
			palletIdErrorMSG:'',
			palletIdError:false,
			palletIdErrorForAlpha:false,
			palletIdErrorForAlphaMSG:'',
			regexForAlphaNumeric:/^[a-zA-Z0-9]{1,30}$/,
			isLoadingSearch:false,
			palletDetails:[],
			showDataTable:false,
			hublist:[]

		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }

    },
		BagCategory: function(isparentbag){
			if (isparentbag==true) {
				return "Parent";
			}else if(isparentbag==false){
				return "Child";
			}
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.hubid = userdetail[0].HubId[0];
		this.getHubList();

	},
	methods: {
		getHubList() {
			this.hublist = []
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					var HubDetails = result.data.ResponseData
					for (var i = 0; i < HubDetails.length; i++) {
						this.hublist.push({
							"value": HubDetails[i].HubID,
							"text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
						})
					}
				}, error => {
					console.error(error)
				})
		},

		onSubmitSearch: function() {
			var self = this
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
				// this.$alertify.success("your message");
			}).catch(() => {
				console.log('errors exist')
				//this.$alertify.error("your message")
			});
		},
			getPalletDetails() {
				this.palletIdError=false;
				this.palletIdErrorMSG = '';
				this.palletIdErrorForAlpha=false;
				this.palletIdErrorForAlphaMSG='';
			if (this.palletId == '' || this.palletId == undefined) {
				this.palletIdError=true;
				this.palletIdErrorMSG = 'Enter Pallet Id';
				return false;
			}
			if(this.regexForAlphaNumeric.test(this.palletId.trim()) == false)
			{
				this.palletIdErrorForAlpha=true;
				this.palletIdErrorForAlphaMSG="Pallet Number Must Be AlphaNumeric";
				return false;
			}
			this.palletDetails=[];

			this.isLoadingSearch = true;
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getPalletReport?palletNumber=' + this.palletId.trim() +'&hubId=' +this.hubid,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.multiPartId=result.data.MultiPartGroupId;

						var hubDetails = [];
						var logData = [];
						for (var i = 0; i < this.hublist.length; i++) {
							hubDetails[this.hublist[i].value] = this.hublist[i].text;
						}
						if (result.data.ResponseData.length > 0) {
							result.data.ResponseData.forEach(function(item) {
								item["nextHubName"] = '';
								if (item.nexthub && hubDetails[item.nexthub]) {
									item["nextHubName"] = hubDetails[item.nexthub];
								}
								logData.push(item);
							});
						}
						this.palletDetails = logData;
						this.showDataTable=true;
						this.$alertify.success(result.data.ReturnMessage);
					} else {
						this.showDataTable=false;
						this.showShipmentDetailsTable=false;
						this.showBagdetailsTable=true;
						this.$alertify.error(result.data.ReturnMessage);
						this.palletDetails = [];
					}
				}, error => {
					console.error(error)
				})
		},
		resetForm(){
		 this.palletIdErrorForAlpha=false;
		 this.palletIdErrorForAlphaMSG='';
		 this.isLoadingSearch= false;
		 this.isLoadingSearchBag= false;
		 this.palletIdError=false;
		 this.palletIdErrorMSG = '';
		 this.showDataTable=false;
		 this.palletId='';
		 this.$validator.reset();
		 this.showBinShipmentDetils=false;
	 }
	}
}



// WEBPACK FOOTER //
// ./src/views/components/PalletReportPages/PalletSummary/PalletSummary.js